export default __webpack_public_path__ + "a1d3450845f9790b40edb22ead65aeb8.png";